module.exports = __webpack_public_path__ + "img/Heather.99e9d176.png";